import { render, staticRenderFns } from "./collectPolicy.vue?vue&type=template&id=f695eadc&scoped=true&"
import script from "./collectPolicy.vue?vue&type=script&lang=js&"
export * from "./collectPolicy.vue?vue&type=script&lang=js&"
import style0 from "./collectPolicy.vue?vue&type=style&index=0&id=f695eadc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f695eadc",
  null
  
)

export default component.exports